var module = angular.module('octopusApp.tenants');

module.controller('TenantAddProjectDialogController', function ($scope, busy, $uibModalInstance, octopusRepository, existingProjects) {
    var isLoading = $scope.isLoading = busy.create();
    var isSavingProject = $scope.isSavingProject = busy.create();
    $scope.adding = { ProjectId: null, Environments: [] };
    $scope.availableEnvironments = [];

    function init() {
        isLoading.promise(octopusRepository.Projects.all().then(function (allProjects) {
            $scope.availableProjects = _.reject(allProjects, function (p) {
                return _.find(existingProjects, function (existing) {
                    return existing.Id === p.Id;
                });
            });
        }));

        $scope.$watch('adding.ProjectId', function(newProjectId) {
            if (!newProjectId) {
                $scope.selectedProject = null;
            }

            $scope.selectedProject = _.find($scope.availableProjects, function(p) {
                return p.Id === newProjectId;
            });
        });
    }

    $scope.getAvailableEnvironments = function () {
        if ($scope.adding.ProjectId) {
            isLoading.promise(octopusRepository.Projects.get($scope.adding.ProjectId).then(function (project) {
                octopusRepository.Progression.getProgression(project).then(function(progression) {
                    $scope.adding.Environments = [];
                    $scope.availableEnvironments = progression.Environments;
                });
            }));
        } else {
            $scope.availableEnvironments = [];
        }
    };

    $scope.enableTenantedDeployments = function () {
        if ($scope.selectedProject) {

            $scope.selectedProject.TenantedDeploymentMode = 'TenantedOrUntenanted';
            isSavingProject.promise(octopusRepository.Projects.modify($scope.selectedProject));
        }
    };

    $scope.close = function () {
        $uibModalInstance.close();
    };

    $scope.save = function () {
        $uibModalInstance.close($scope.adding);
    };

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_add_project_dialog_controller.js
// module id = 6675616197259388
// module chunks = 1